/**
 * Merge one /api/testingdata response per metric into one chart payload.
 *
 * Each response holds only the dates on which its metric has a value. The
 * merge keys rows by date so a metric with fewer dates does not truncate or
 * shift the other metrics. Dates arrive as "YYYY-MM-DD" strings, so a string
 * sort gives chronological order.
 */
export function mergeTestingDataByDate(responses) {
  const optionsV2 = [];
  const rowsByDate = new Map();

  responses.forEach((response) => {
    optionsV2.push(...(response?.optionsV2 || []));
    (response?.data || []).forEach((row) => {
      const dateKey = String(row.date);
      rowsByDate.set(dateKey, { ...(rowsByDate.get(dateKey) || {}), ...row });
    });
  });

  const data = Array.from(rowsByDate.values()).sort((a, b) =>
    String(a.date).localeCompare(String(b.date))
  );

  return { optionsV2, data };
}
